import * as React from 'react'
import { NavLink } from 'react-router-dom'
import './YNavLink.scss'

export interface ILinkProps {
  to: string
  className?: string
  children?: any
  onMouseOver?(): void
  onClick?(): void
}

export class YNavLink extends React.Component<ILinkProps> {
  render() {
    const { children, className, ...rest } = this.props

    const BEM = () => {
      const list = ['link']

      if (className) {
        list.push(className)
      }

      return list.join(' ')
    }

    return (
      <NavLink className={(isActive) => BEM() + (isActive ? ' link-active' : '')} {...rest}>
        {children}
      </NavLink>
    )
  }
}
